export default __webpack_public_path__ + "static/media/ZZ.693e4270.webp";